import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import CohortCardItems from './CohortCardItems';

const CohortCards = ({
  canCreate,
  category,
  handleScroll,
  items,
  itemsPerRow,
  newCohortCode,
  readErrors,
  readStatus,
  onCheckBoxClick,
  showStatus,
  showTools,
  single,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-cohort-cards"
    entity="cohort"
    handleScroll={handleScroll}
    icon="table"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={codeUrl(urls.COHORT, newCohortCode, '#')}
  >
    <CohortCardItems
      category={category}
      items={items}
      onCheckBoxClick={onCheckBoxClick}
      showStatus={showStatus}
      showTools={showTools}
      single={single}
    />
  </InfiniteScrollCards>
);

export default CohortCards;
